module.exports = __webpack_public_path__ + "img/logo.d9a4755.svg";